import { TableCell, TableHead, TableRow, type Theme, Typography } from '@mui/material';

const styles = {
  headerRow: {
    backgroundColor: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c100,
  },
  headerCell: {
    padding: 'clamp(8px, 1vw, 8px)',
  },
  headerText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 'clamp(10px, 1.5vw, 14px)',
    fontFamily: (theme: Theme) => theme.fonts.inter,
  },
};

export const ComponentTableHeader = ({ children }: { children: React.ReactNode }) => (
  <TableHead>
    <TableRow sx={styles.headerRow}>
      <TableCell colSpan={2} align='center' sx={styles.headerCell}>
        <Typography sx={styles.headerText}>{children}</Typography>
      </TableCell>
    </TableRow>
  </TableHead>
);
